<template>

    <Toast/>

    <MenuHealthCompact/>

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Dashboard</h3>

                </div>

            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";

export default {
    components: {
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[PmOverviewDashboard][mounted] System is active.");
                console.log("[PmOverviewDashboard][mounted] Data = ", data);
            })
            .catch(e => {
                console.log("[PmOverviewDashboard][mounted] System is NOT active.");
                console.log("[PmOverviewDashboard][mounted] Error = ", e);

                this.userStore.clearUser;
                this.$router.push("login");
            });

        try {
            // Attempt to get user data
            const userData = UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
        } catch (e) {
            console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        this.profile.companyId = this.userStore.activeCompanyId;
    },
    data() {

        return {
            profile: {},
            activeTab: 1
        }
    },
    methods: {
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
